import React, { Component } from 'react';
import BlockR from './../BlockR';

var DateFilter = React.createClass({
  handlerSelect: function(data, name){
    var obj = { ...this.props.data }
    this.props.actionFilter(name, 'date');
    obj.dateData.select = data;
    this.props.actionDataFilter(obj)
  },
  render: function(){
    return(
      <div className="blockInside">
        <BlockR
          actionSelect={this.handlerSelect}
          filter={function(a){
            var now = new Date(),
                today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).valueOf(),
                createProfile = a.createProfile ? Date.parse(a.createProfile).valueOf() : Date.parse(a.updatedAt).valueOf();

            if(createProfile > today){
              return true
            }else{
              return false
            }

          }}
          select={this.props.data.dateData.select}
          id={0}
          name="Сегодня"
        />
        <BlockR
          actionSelect={this.handlerSelect}
          filter={function(a){
            var now = new Date(),
                today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).valueOf(),
                createProfile = a.createProfile ? Date.parse(a.createProfile).valueOf() : Date.parse(a.updatedAt).valueOf();

            if(createProfile < today){
              return true
            }else{
              return false
            }

          }}
          select={this.props.data.dateData.select}
          id={1}
          name="Раньше"
        />
      </div>
    );
  }
});

export default DateFilter;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Filter/DateFilter/index.jsx
 **/